export default __webpack_public_path__ + "static/media/icon_linkedin.2f553aff.svg";